import React from "react";

const KaranatakaHrdWhat = () => {
  return (
    <div className="karHrdHeadContent">
      <h2>
        What is HRD <span>Attestation</span>?
      </h2>
      <p>
        HRD attestation is the process of validating educational documents by
        the Human Resource Development department of the state where the
        certificate was issued. This attestation is necessary to confirm the
        legitimacy of the documents and is a prerequisite for further
        attestation processes, such as MEA (Ministry of External Affairs)
        attestation and embassy attestation.
      </p>
    </div>
  );
};

export default KaranatakaHrdWhat;
